import _ from 'lodash';
import { JwtClaims } from '../models/payload';

export function decodeIdToken(token: string): JwtClaims {
  try {
    const payload = token.split('.')[1];
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64)) as JwtClaims;
  } catch {
    return {};
  }
}

export function removeUndefinedProperties(obj: any): any {
    return _.pickBy(obj, (value) => value !== undefined && value !== null && value !== '');
}

export function isAlphanumeric(str: string): boolean {
    const regex = /^[a-zA-Z0-9]{1,3}$/;
    return regex.test(str);
}

export function escapeRegex(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function stripDuplicateTitleHeading(markdown: string, title: string): string {
    const headingRegex = new RegExp(`^\\s*#\\s*${escapeRegex(title)}\\s*\\n?`, 'i');
    return markdown.replace(headingRegex, '');
}